import { FileUploadState } from "./types";
import { DEFAULT_FILE_UPLOAD_SIZE_MB } from "@/helperMethods/fileUpload";

/**
 * Initial state for the File Storage module.
 * Defaults to Azure storage backend.
 */
const state: FileUploadState = {
  storageType: "azure",
  fileUploadSizeLimit: DEFAULT_FILE_UPLOAD_SIZE_MB,
  fileUploadSizeCeiling: DEFAULT_FILE_UPLOAD_SIZE_MB,
  fileUploadAllowedExtensions: [],
  fileUploadAllowedMimeTypes: [],
};

export default state;
